import sysInfoRepository from './sysInfoRepository';
import preLoginInfoRepository from './preLoginInfoRepository';
import authRepository from './authRepository';
import lastTimeRepository from './lastTimeRepository';
import damSupportInfoRepository from './damSupportInfoRepository';
import damDischargeInfoRepository from './damDischargeInfoRepository';
import tableInfoRepository from './tableInfoRepository';
import kurihashiKakuhoRepository from './kurihashiKakuhoRepository';
import logRepository from './logRepository';
import telemeterRepository from './telemeterRepository';
import telemeterBasinRepository from './telemeterBasinRepository';

const RepositoryFactory = {
  getSysInfo: sysInfoRepository,
  log: logRepository,
  lastTime: lastTimeRepository,
  auth: authRepository,
  preLoginInfo: preLoginInfoRepository,
  damSupportInfo: damSupportInfoRepository,
  damDischargeInfo: damDischargeInfoRepository,
  getTableInfo: tableInfoRepository,
  getKurihashiKakuho: kurihashiKakuhoRepository,
  getTelemeter: telemeterRepository,
  getTelemeterBasin: telemeterBasinRepository,
};

export default RepositoryFactory;
